import { type RequestBody } from '../http/type-helpers';

import { CONSENT_RECONCILIATION_ENDPOINT } from '@/constants/endpoints';
import { typedHttp } from '@/modules/http';

export function getConsentReconciliation(
  data: RequestBody<typeof CONSENT_RECONCILIATION_ENDPOINT>
) {
  return typedHttp.post(CONSENT_RECONCILIATION_ENDPOINT, data, {
    withAuth: true,
  });
}
